import * as R from 'remeda'
import { match } from 'ts-pattern'
import { z } from 'zod'

import { type SurveyGroupCustomerAttributeFilterItemInput } from '~/gql/graphql'

import { type SurveyGroupFilterGroups } from './surveyGroupFilterGroups'

/**
 * SurveyGroupFilterGroups から SurveyGroupCustomerAttributeFilterItemInput[][] に変換します。
 *
 * @param filterGroups - SurveyGroupFilterGroups 。
 * @returns SurveyGroupCustomerAttributeFilterItemInput[][] 。
 */
export function toSurveyGroupFilterItemInputGroups(
  filterGroups: SurveyGroupFilterGroups,
): SurveyGroupCustomerAttributeFilterItemInput[][] {
  return filterGroups.map((filterGroup) =>
    filterGroup.map((filter) =>
      match(filter)
        .with({ category: 'Question' }, R.identity())
        .with({ category: 'CustomerAttribute' }, (filter) => ({
          ...R.pick(filter, ['category']),
          customerAttribute: {
            ...R.pick(filter.customerAttribute, [
              'surveyGroupCustomerAttributeGroupId',
              'operation',
            ]),
            customerAttributes: filter.customerAttribute.customerAttributes.map(
              (customerAttribute) => {
                const parsed = z
                  .string()
                  .uuid()
                  .safeParse(customerAttribute.idLike)
                const surveyGroupCustomerAttributeId = parsed.success
                  ? parsed.data
                  : null
                const name = customerAttribute.name

                return { surveyGroupCustomerAttributeId, name }
              },
            ),
          },
        }))
        .with({ category: 'BrandSegments' }, R.identity())
        .exhaustive(),
    ),
  )
}
